import { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItem } from '../form-item/FormItem';
import { InputTextarea } from '../input-textarea/InputTextarea';
import { ValidationProps } from '../input-validation/InputValidation';

import './InputTextAreaCharacterCount.scss';

type InputTextAreaCharacterCountProps = {
    headerText?: string;
    label: string;
    placeholder: string;
    value: string | undefined;
    onChange?: (value: string) => void;
    maxLength?: number;
    readOnly?: boolean;
} & ValidationProps &
    Omit<InputHTMLAttributes<HTMLTextAreaElement>, 'onChange'>;
export const InputTextAreaCharacterCount = ({
    headerText,
    label,
    placeholder,
    value,
    onChange,
    maxLength = 255,
    readOnly = false,
    ...rest
}: InputTextAreaCharacterCountProps) => {
    const { t } = useTranslation(['uiDomain', 'domainModel']);

    const remainingCharactersCount = maxLength - (value?.length ?? 0);

    return (
        <div className="input-textarea-character-count">
            <FormItem header={headerText}>
                <InputTextarea
                    name="materialAdditionalComment"
                    placeholder={placeholder}
                    onChange={onChange}
                    maxLength={maxLength}
                    label={label}
                    value={value}
                    readOnly={readOnly}
                    {...rest}
                />
                {!readOnly && (
                    <span className="comments-label">
                        {t('uiDomain:inputCharacterCount.inputCharacterRemaining', {
                            count: remainingCharactersCount,
                            remainingCharactersCount,
                        })}
                    </span>
                )}
            </FormItem>
        </div>
    );
};
